import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';

import { StationFilterContext } from '../../contexts/StationFilterContext';
import { StationCodeSelector } from './StationCodeSelector'


export const StationSelectorFormSimple = () => {
  const { state, dispatch } = useContext(StationFilterContext);
  const { t } = useTranslation();
  
  const handleInputValueChanged = (event) => {
    if (event.target && event.target.name) {
      const {name, value} = event.target
      const [category, key] = name.split(/\.(.+)/)
      if (category && key) {
        dispatch({
          type: 'SET_FILTER_VALUE',
          category,
          key,
          value,
        })
      }
    }
  }

  const handleSelectorTypeChanged = (event) => {
    if (event.target) {
      const {value, checked} = event.target;
      // const [_, selectorType] = name.split(/\.(.+)/)
      if (checked) {
        dispatch({
          type: 'SET_SELECTOR_TYPE',
          value,
        })
      }      
    }    
  }

  const handleLocationFilterTypeChanged = (event) => {
    const {checked, value} = event.target;
    dispatch({
      type: 'SET_FILTER_VALUE',
      category: 'location',
      key: 'type',
      value: checked ? value: '',
    })
    if (checked) {
      dispatch({
        type: 'SET_SELECTOR_TYPE',
        value: 'byCondition',
      })
    }
  }

  return (
    <form>
      <div className="mb4">
        <label className="datatable_select_radio" htmlFor="stationFilter.selectorType.all">
          <input type="radio" id="stationFilter.selectorType.all" 
            name="selectorType" value="all" className="with-gap" 
            checked={state.selectorType === 'all'}
            onChange={handleSelectorTypeChanged}
          />
          <span>{t('form.all')}</span>
        </label>
      </div>
      <div className="left multiinput_container">
        <label className="datatable_select_radio">
          <input type="radio" name="selectorType" className="with-gap"
            value="boxRange" aria-label="관측소 위경도 범위 지정"
            checked={state.selectorType === 'byCondition' && state.location.type === 'boxRange'}
            onChange={handleLocationFilterTypeChanged}
          />
          <span>{t('w.latitude')}<span className="hide-on-med-and-down">&nbsp;{t('w.range')}</span></span>
        </label>
        <input type="text" name="location.minLat" placeholder="35.0"
          className="multiinput"
          aria-label="관측소 최소 위도"
          onBlur={handleInputValueChanged}
        />
        &nbsp; ~ &nbsp;
        <input type="text" name="location.maxLat" placeholder="38.0"
          className="multiinput"
          aria-label="관측소 최대 위도"
          onBlur={handleInputValueChanged}
        />
      </div>
      <div className="left multiinput_container">
        <label className="datatable_select_radio">
          <input type="radio" name="selectorType" className="with-gap" style={{cursor: 'default'}} tabIndex="-1" disabled/>
          <span className="be_disabled">{t('w.longitude')}<span className="hide-on-med-and-down">&nbsp;{t('w.range')}</span></span>
        </label>
        <input type="text" name="location.minLon" placeholder="126.0"
          className="multiinput"
          aria-label="관측소 최소 경도"
          onBlur={handleInputValueChanged}
        />
        &nbsp; ~ &nbsp;
        <input type="text" name="location.maxLon" placeholder="129.0"
          className="multiinput"
          aria-label="관측소 최대 경도"
          onBlur={handleInputValueChanged}
        />
      </div>
      <div className="clearfix"></div>
      <div className="left multiinput_container">
        <label className="datatable_select_radio">
          <input type="radio" name="selectorType" className="with-gap"
            value="circleRange" aria-label="관측소 위경도 중심 및 범위 지정"
            checked={state.selectorType === 'byCondition' && state.location.type === 'circleRange'}
            onChange={handleLocationFilterTypeChanged}
          />
          <span>
            <span className="hide-on-med-and-down">{t('form.location.latitudeAndLongitude')} </span>
            {t('form.location.center')}
          </span>
        </label>
        <input type="text" name="location.centralLat" placeholder="36.3"
          className="multiinput"
          aria-label="관측소 중심 위도"
          onBlur={handleInputValueChanged}
        />
        , &nbsp;
        <input type="text" name="location.centralLon" placeholder="127.5"
          className="multiinput"
          aria-label="관측소 중심 경도"
          onBlur={handleInputValueChanged}
        />
      </div>
      <div className="left multiinput_container">
        <label className="datatable_select_radio">
          <input type="radio" name="selectorType" className="with-gap" style={{cursor: 'default'}} tabIndex="-1" disabled/>
          <span className="be_disabled">{t('form.location.radius')}</span>
        </label>
        <input type="text" name="location.maxRadius" placeholder="30"
          className="multiinput"
          aria-label="관측소 반경"
          onBlur={handleInputValueChanged}
        />
        km
      </div>
      <div className="clearfix"></div>
      <div>
        <label className="datatable_select_radio" htmlFor="stationFilter.selectorType.byCode">
          <input type="radio" id="stationFilter.selectorType.byCode" name="selectorType"
            value="byCode" className="with-gap"
            checked={state.selectorType === 'byCode'}
            onChange={handleSelectorTypeChanged}
          />
          <span>{t('form.selectionDirectly')}</span>
          &nbsp;
        </label>
        <br className="hide-on-med-and-up" />
        {state.selectorType === 'byCode' && <StationCodeSelector />}
      </div>
    </form>
  )
}

